export default "__VITE_ASSET__cae5a161__"